import React, { useState, useEffect } from "react";
import "./modal.css";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import { updateUser } from "../../services/userService";

const EditModal = ({ setIsOpen, setLoadingUsers, data, setUsers }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(data.Name);
  const [email, setEmail] = useState(data.email);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [role, setRole] = useState(data.role);
  const [betaEnabled, setBetaEnabled] = useState(data.betaEnabled);
  const [chooseAi, setChooseAI] = useState(data.AI);
  const [medicalGroup, setMedicalGroup] = useState(data.medicalGroup);

  useEffect(() => {
    if (loading === true) {
      if (name === "") {
        toast("Name is required");
        setLoading(false);
        return;
      }

      if (email === "") {
        toast("User Id is required");
        setLoading(false);
        return;
      }

      if (email.length < 6) {
        toast("User Id must be greater than 6 characters");
        setLoading(false);
        return;
      }

      if (
        password?.length &&
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\(\)])[A-Za-z\d@$!%*?&\(\)]{8,}$/.test(
          password
        )
      ) {
        toast(
          "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character (@$!%*?&()) is required for password"
        );
        setLoading(false);
        return;
      }

      if (confirmPassword !== password) {
        toast("The passwords are not mtaching. Please try again");
        setLoading(false);
        return;
      }

      const updateUserDetails = async () => {
        try {
          const res = await updateUser({
            email,
            password,
            name,
            id: data.id,
            role,
            AI: chooseAi,
            betaEnabled,
            medicalGroup,
          });
          if (res?.status === "success") {
            toast("Updated User Sucessfully");
            const updatedUser = res.result;
            setUsers((prevUsers) => {
              return prevUsers.map((user) => {
                if (user.id === res.result.id) {
                  return {
                    ...user,
                    Name: updatedUser.Name,
                    email: updatedUser.email,
                    id: updatedUser.id,
                    isActive: updatedUser.isActive,
                    role: updatedUser.role,
                    AI: updatedUser.AI,
                    betaEnabled: betaEnabled,
                    medicalGroup,
                  };
                } else {
                  return user;
                }
              });
            });

            setIsOpen(false);
            setLoading(false);
          } else throw new Error("User Update Failed");
        } catch (e) {
          setLoading(false);
          toast(
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "An error occured. Please try again"
          );
        }
      };

      updateUserDetails();
    }
    // eslint-disable-next-line
  }, [loading]);

  return (
    <>
      <div className="darkBG" onClick={() => setIsOpen(false)} />
      <ToastContainer />
      <div className="centered">
        <div className="modal">
          <div className="modalHeader">
            <h5 className="heading">Edit Details</h5>
            <button className="closeBtn" onClick={() => setIsOpen(false)}>
              &times;
            </button>
          </div>

          <div className="loginCardWrapper" style={{ padding: "10px" }}>
            <div
              style={{
                alignItems: "baseline",
              }}
              className="flex flex-row gap-1 justify-between items-baseline"
            >
              <div className="flex-1">
                <span className="title">Name</span>
                <input
                  type="text"
                  value={name}
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                  className="emailInput"
                />
              </div>

              <div className="flex-1">
                <span className="title">User ID</span>
                <input
                  type="text"
                  value={email}
                  placeholder="Enter your User Id"
                  onChange={(e) => setEmail(e.target.value)}
                  className="emailInput"
                />
              </div>
            </div>

            <div
              style={{
                alignItems: "baseline",
              }}
              className="flex flex-row gap-1 justify-between align-baseline"
            >
              <div className="flex-1">
                <span className="title">Password </span>
                <div className="passwordInputWrapper">
                  <div className="passwordInputInnerWrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      placeholder="Enter a new password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className={`eye-icon ${showPassword ? "visible" : ""}`}
                      style={{ color: "#888888" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <span
                  className="resetPasswordTitle"
                  style={{ marginTop: "10px" }}
                >
                  Confirm Password
                </span>
                <div className="passwordInputWrapper">
                  <div className="passwordInputInnerWrapper">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      placeholder="Enter your password"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <span
                      className={`eye-icon ${
                        showConfirmPassword ? "visible" : ""
                      }`}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <span className="title">Choose AI</span>
            <select
              style={{
                padding: "10px",
                outline: "none",
                border: "1px solid #EAECF0",
                color: "#ADB5BD",
                borderRadius: "10px",
              }}
              onChange={(e) => {
                setChooseAI(e.target.value);
              }}
              value={chooseAi}
            >
              <option disabled>Choose AI</option>
              <option value={"BASTIONGPT"}>BASTION-GPT</option>
              <option value={"OPENAI"}>OPEN-AI</option>
              <option value={"DEFAULT"}>DEFAULT</option>
              <option value={"GPT5"}>GPT-5</option>
            </select>

            <span className="title">Select Role </span>
            <select
              style={{
                padding: "10px",
                outline: "none",
                border: "1px solid #EAECF0",
                color: "#ADB5BD",
                borderRadius: "10px",
              }}
              onChange={(e) => {
                setRole(e.target.value);
              }}
              value={role}
            >
              <option disabled>Medical Group</option>
              <option value={"Provider"}>Provider</option>
              <option value={"Scribe"}>Scribe</option>
              <option value={"Admin"}>Admin</option>
            </select>

            <span className="title">Medical Group</span>
            <select
              style={{
                padding: "10px",
                outline: "none",
                border: "1px solid #EAECF0",
                color: "#ADB5BD",
                borderRadius: "10px",
              }}
              onChange={(e) => {
                setMedicalGroup(e.target.value);
              }}
              value={medicalGroup}
            >
              <option disabled>Choose AI</option>
              <option value={"Middletown Medical"}>Middletown Medical</option>
              <option value={"Northern Medical"}>Northern Medical</option>
              <option value={"Community Primary Care"}>
                Community Primary Care
              </option>
            </select>

            <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
              <button
                className="loginButton"
                style={{
                  border: "none",
                  cursor: loading ? "not-allowed" : "pointer",
                  flex: 1,
                  opacity: loading ? 0.6 : 1,
                }}
                onClick={() => {
                  if (!loading) setLoading(true);
                }}
                disabled={loading}
              >
                {loading ? "Loading..." : "SAVE"}
              </button>

              <button
                className="loginButton"
                onClick={() => setIsOpen(false)}
                style={{
                  border: "none",
                  cursor: loading ? "not-allowed" : "pointer",
                  flex: 1,
                  opacity: loading ? 0.6 : 1,
                }}
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditModal;
